import { api } from "./client";

export function listSites({ signal } = {}) {
  return api("/api/sites", { signal });
}
